<page-heading
  [title]="'task.home.pageTitle' | translate"
  [description]="'task.home.pageDescription' | translate"
/>

<!--
  The activity workspace (SPEC-2026-10-crm-activities-cadence RF-35, plan AD-11):
  Hoje (default) · Semana · Mês · Calendário · Painel · Lista. The tab state lives in the
  component, not in Bootstrap's data attributes, so a view is created only when its tab is shown.
-->
<ul class="nav nav-tabs nav-bordered font-16" role="tablist">
  <li class="nav-item" role="presentation">
    <a class="nav-link" [class.active]="activeTab === 'today'" href="javascript:void(0);" role="tab" [attr.aria-selected]="activeTab === 'today'" (click)="onTabClick('today')">
      <i class="mdi mdi-calendar-today d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'task.home.tabToday' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" [class.active]="activeTab === 'week'" href="javascript:void(0);" role="tab" [attr.aria-selected]="activeTab === 'week'" (click)="onTabClick('week')">
      <i class="mdi mdi-calendar-week d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'task.home.tabWeek' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" [class.active]="activeTab === 'month'" href="javascript:void(0);" role="tab" [attr.aria-selected]="activeTab === 'month'" (click)="onTabClick('month')">
      <i class="mdi mdi-calendar-month d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'task.home.tabMonth' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" [class.active]="activeTab === 'calendar'" href="javascript:void(0);" role="tab" [attr.aria-selected]="activeTab === 'calendar'" (click)="onTabClick('calendar')">
      <i class="mdi mdi-calendar-blank-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'task.home.tabCalendar' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" [class.active]="activeTab === 'dashboard'" href="javascript:void(0);" role="tab" [attr.aria-selected]="activeTab === 'dashboard'" (click)="onTabClick('dashboard')">
      <i class="mdi mdi-view-dashboard-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'task.home.tabDashboard' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" [class.active]="activeTab === 'task-list'" href="javascript:void(0);" role="tab" [attr.aria-selected]="activeTab === 'task-list'" (click)="onTabClick('task-list')">
      <i class="mdi mdi-format-list-bulleted d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'task.home.tabList' | translate }}</span>
    </a>
  </li>
</ul>

<!-- The area's one filter block, serving every tab (RF-39); type and outcome are E4's additions. -->
@if (activeTab !== 'dashboard') {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row g-3 justify-content-end">
            @if (showSearch) {
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 input-trend-search">
                <input
                  type="search"
                  #searchBox
                  class="form-control"
                  [placeholder]="'task.home.searchPlaceholder' | translate"
                  (keyup)="search(searchBox.value)"
                />
                <span class="mdi mdi-magnify search-icon ml-2"></span>
              </div>
            }

            <!-- Responsible person: only for users permitted to see all deals (RF-44). -->
            @if (canChooseResponsible) {
              <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
                <!-- Design (canvas "Hoje"): the button carries "filter: current choice", "Todos" when nothing is chosen. -->
                <button [matMenuTriggerFor]="filterUser" type="button" class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle">
                  {{ 'task.userFilter' | translate }}: {{ (selectedUserId ? labelUser : 'task.home.filterAll') | translate }}
                </button>
                <mat-menu #filterUser="matMenu" class="custom-menu-panel">
                  <button mat-menu-item (click)="changeUser(null)">{{ 'task.home.filterAll' | translate }}</button>
                  @for (user of listUser; track user._id) {
                    <button mat-menu-item (click)="changeUser(user)">{{ user.name }}</button>
                  }
                </mat-menu>
              </div>
            }

            @if (activeTab === 'task-list') {
              <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
                <button [matMenuTriggerFor]="filterOwner" type="button" class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle">
                  {{ 'task.ownerFilter' | translate }}: {{ (selectedOwnerId ? labelOwner : 'task.home.filterAll') | translate }}
                </button>
                <mat-menu #filterOwner="matMenu" class="custom-menu-panel">
                  @if (isAdmin()) {
                    <button mat-menu-item (click)="changeOwner(null)">{{ 'task.home.filterAll' | translate }}</button>
                  }
                  @for (user of listUser; track user._id) {
                    <button mat-menu-item (click)="changeOwner(user)">{{ user.name }}</button>
                  }
                </mat-menu>
              </div>
            }

            <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
              <button [matMenuTriggerFor]="filterStatus" type="button" class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle">
                {{ 'task.statusFilter' | translate }}: {{ (selectedStatus.length ? statusLabel : 'task.home.filterAll') | translate }}
              </button>
              <mat-menu #filterStatus="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="changeStatus(null)">{{ 'task.home.filterAll' | translate }}</button>
                @for (st of status; track $index) {
                  <button mat-menu-item (click)="changeStatus(st.value)">{{ st.label | translate }}</button>
                }
              </mat-menu>
            </div>

            <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
              <button [matMenuTriggerFor]="filterType" type="button" class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle">
                {{ 'task.home.typeFilter' | translate }}: {{ (selectedType ? typeLabel : 'task.home.filterAll') | translate }}
              </button>
              <mat-menu #filterType="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="changeType(null)">{{ 'task.home.filterAll' | translate }}</button>
                @for (type of types; track type.value) {
                  <button mat-menu-item (click)="changeType(type.value)">{{ type.label | translate }}</button>
                }
              </mat-menu>
            </div>

            <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
              <button [matMenuTriggerFor]="filterOutcome" type="button" class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle">
                {{ 'task.home.outcomeFilter' | translate }}: {{ (selectedOutcome ? outcomeLabel : 'task.home.filterAll') | translate }}
              </button>
              <mat-menu #filterOutcome="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="changeOutcome(null)">{{ 'task.home.filterAll' | translate }}</button>
                @for (outcome of outcomes; track outcome.value) {
                  <button mat-menu-item (click)="changeOutcome(outcome.value)">{{ outcome.label | translate }}</button>
                }
              </mat-menu>
            </div>

            @if (activeTab === 'task-list') {
              <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
                <button [matMenuTriggerFor]="filterPriority" type="button" class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle">
                  {{ 'task.priorityFilter' | translate }}: {{ (selectedPriority.length ? priorityLabel : 'task.home.filterAll') | translate }}
                </button>
                <mat-menu #filterPriority="matMenu" class="custom-menu-panel">
                  <button mat-menu-item (click)="changePriority(null)">{{ 'task.home.filterAll' | translate }}</button>
                  @for (st of priority; track $index) {
                    <button mat-menu-item (click)="changePriority(st.value)">{{ st.label | translate }}</button>
                  }
                </mat-menu>
              </div>
            }

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 btn-group trend-button">
              <button type="button" class="btn btn-success fw-bold" [routerLink]="['/task/new']">
                {{ 'task.home.addButton' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<div class="mt-2">
  @switch (activeTab) {
    @case ('today') {
      <app-task-today [filters]="filters" />
    }
    @case ('week') {
      <app-task-range mode="week" [filters]="filters" />
    }
    @case ('month') {
      <app-task-range mode="month" [filters]="filters" />
    }
    @case ('calendar') {
      <app-task-calendar [filters]="filters" />
    }
    @case ('dashboard') {
      <app-task-dashboard />
    }
    @case ('task-list') {
      <!-- Lista — the table that stays as it was. -->
      <div class="card">
        @if(!loadingContent) {
          @if(pager.list.length > 0) {
            <table class="table table-hover table-centered mb-0">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">{{ 'task.home.columnTitle' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'task.home.columnAssignee' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'task.home.columnCreatedBy' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'task.home.columnDeadline' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'task.home.columnStatus' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'task.home.columnPriority' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (task of pager.list; track $index) {
                  <tr class="cursor-pointer" (click)="goToTaskDetail(task._id!)">
                    <td>
                      {{ task.name }}
                      <!--
                        The opportunity this task belongs to
                        (SPEC-2026-08-crm-pipeline-deals-radar). Deal activities and platform
                        tasks are the same records (ADR-004), so a task created from a deal has
                        to be recognisable here — otherwise the two screens show the same rows
                        with no way to tell them apart.
                      -->
                      @if (task.card) {
                        <br />
                        <small class="text-muted d-inline-flex align-items-center">
                          <i class="mdi mdi-tag-outline me-1"></i>
                          {{ dealName(task) }}
                          <!-- E4 RF-52: the deal was deleted since — the task is one with no deal. -->
                          @if (isDealRemoved(task)) {
                            <span class="badge campaign-badge is-neutral ms-1">
                              <i class="mdi mdi-delete-outline me-1"></i>{{ 'task.detail.dealRemoved' | translate }}
                            </span>
                          }
                          @if (task.isNextAction && !isDealRemoved(task)) {
                            <span class="badge bg-soft-primary text-primary ms-1">
                              {{ 'task.home.isNextAction' | translate }}
                            </span>
                          }
                        </small>
                      }
                    </td>
                    <td>
                      <div class="table-user gap-1 d-flex align-items-center">
                        <img
                          [src]="$safeNavigationMigration(task?.user?.image)"
                          [alt]="$safeNavigationMigration(task?.user?.name)"
                          class="img-fluid avatar-xs rounded-circle"
                          (error)="onImageError($event)"
                        />
                        {{ task?.user?.name ?? ('task.home.noAssignee' | translate) }}
                      </div>
                    </td>
                    <td>
                      <div class="table-user gap-1 d-flex align-items-center">
                        @if(task?.owner) {
                          <img
                            [src]="getImage($safeNavigationMigration(task?.owner))"
                            [alt]="getOwnerUserName($safeNavigationMigration(task?.owner))"
                            class="img-fluid avatar-xs rounded-circle"
                            (error)="onImageError($event)"
                          />
                          <div class="ms-2">
                            <h5 class="mt-1 font-14">
                              {{ getOwnerUserName($safeNavigationMigration(task?.owner)) }}
                            </h5>
                          </div>
                        }
                      </div>
                    </td>
                    <td>
                      <span>
                        @if (task.deadlineAt) {
                          {{ task.deadlineAt | timezoneDate : (task.untimed ? "DD/MM/YYYY" : "DD/MM/YYYY - HH:mm") : getTimezoneCompanyCurrentUser() }}
                          @if (task.untimed) {
                            <small class="text-muted d-block">{{ 'task.activity.untimed' | translate }}</small>
                          }
                        } @else {
                          <!-- A task with no date appears in no day view: marked so it can be found and scheduled. -->
                          <span
                            class="badge campaign-badge is-neutral"
                            [matTooltip]="'task.activity.noDateHint' | translate"
                            [attr.aria-label]="'task.activity.noDateHint' | translate"
                          >
                            <i class="mdi mdi-calendar-remove-outline me-1"></i>{{ 'task.activity.noDate' | translate }}
                          </span>
                        }
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge bg-info font-14"
                        [ngClass]="{
                          'bg-warning': task?.status === 'PENDING',
                          'bg-info': task?.status === 'IN_PROGRESS',
                          'bg-success': task?.status === 'DONE'
                        }"
                      >
                        {{ translateEnuns(task.status) | translate }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge font-14"
                        [ngClass]="{
                          'bg-warning': task.priority === 'HIGH',
                          'bg-primary': task.priority === 'MEDIUM',
                          'bg-secondary': task.priority === 'LOW' || task.priority === 'NO PRIORITY',
                          'bg-danger': task.priority === 'URGENT' || task.priority === 'CRITICAL'
                        }"
                      >
                        {{ translateEnuns(task.priority) | translate }}
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (pager.total > pager.perPage) {
              <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
            }
          } @else {
            <empty-records-component
              icon="ri-task-line"
              [message]="'task.home.emptyTasks' | translate"
            />
          }
        } @else {
          <content-loading-list />
        }
      </div>
    }
  }
</div>
